import React, {useState} from "react";
import logo from './../logo.png';
import ReCAPTCHA from "react-google-recaptcha";
import chaves from './../chaves.json';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputTextarea } from 'primereact/inputtextarea';
import 'primeicons/primeicons.css';
import Alertas from "./../alertas";
import api from "./../api";
import { chaveRecaptcha } from "./../captcha";

function FormMilhas() {

  const tam_descricao = 1000;

  const [file_rg, setFile_rg] = useState(null);
  const [file_cpf, setFile_cpf] = useState(null);
  const [file_cr, setFile_cr] = useState(null);
  const [file_milhas, setFile_milhas] = useState(null);
  const [file_outros, setFile_outros] = useState(null);

  const [nome, setNome] = useState("");
  const [cpf, setCpf] = useState(""); 
  const [rg, setRg] = useState("");
  const [endereco, setEndereco] = useState(""); 
  const [valor, setValor] = useState("");
  const [telefone, setTelefone] = useState("");
  const [email, setEmail] = useState("");
  const [texto, setTexto] = useState("");
  const [conttexto, setConttexto] = useState(0);
  
  const [recaptcha, setRecaptcha] = useState(null);
  const [load, setLoad] = useState(false);

  // Retirar Log do captchar após configuração
  function captcharFunction(r) {
    setRecaptcha(r);
  }

  function expira_captcha() {
    setRecaptcha(null);
  }

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Accept': 'application/json'
    }
  };

  function limpar() {
    setNome("");
    setCpf("");
    setRg("");
    setEndereco("");
    setValor("");
    setTelefone("");
    setEmail("");
    setTexto("");
    setConttexto(0);

    setFile_cpf(null);
    setFile_rg(null);
    setFile_milhas(null);
    setFile_outros(null);
    setFile_cr(null);
  }

  const formatarMoeda = (inputValue) => {
    const valorNumerico = inputValue.replace(/\D/g, '');
    const valorFormatado = (parseInt(valorNumerico) / 100).toFixed(2).replace('.', ',');
    setValor(`R$ ${valorFormatado}`)
  };


  function enviar_email() {
    if( nome && rg && cpf && endereco && valor && telefone && email && texto && file_rg && file_cpf && file_cr && file_milhas){
      setLoad(true);

      const formData = new FormData();
      formData.append("nome", nome);
      formData.append("rg", rg);
      formData.append("cpf", cpf);
      formData.append("endereco", endereco);
      formData.append("valor", valor);
      formData.append("telefone", telefone);
      formData.append("email", email);
      formData.append("texto", texto);

      formData.append("attachment_0", file_rg);
      formData.append("attachment_1", file_cpf);
      formData.append("attachment_2", file_cr);
      formData.append("attachment_3", file_milhas);

      if(file_outros){
        formData.append("attachment_4", file_outros);
      }

      api.post('/email_123_milhas/', formData, config)
      .then((res)=>{
        if(res.status == 200){
          setLoad(false);
          limpar();
          Alertas.sucesso("Dados enviados");
        }else{
          setLoad(false);
          if (!recaptcha) {
              Alertas.erro("Faça a verificação reCAPTCHA");
            } else {
              Alertas.erro("Erro ao enviar formulário");
            }
        }
      }).catch((err)=>{
        setLoad(false);
        Alertas.erro(err);
      })
    }else{
      Alertas.toast_cuidado("Preencha os campos obrigatórios")
    }
  }

  function chanceTexto(t) {
    let len = t.length;
    if(len < tam_descricao + 1){
      setTexto(t);
      setConttexto(len);
    }
  }

  function changeFiles(file, tipo) {

      const maxSize = 3 * 1024 * 1024; // 3 MB em bytes

      if (file.size > maxSize) {
        Alertas.atencao('Tamanho não permitido. Por favor escolha um arquivo de no máximo 3 MB.');
      }else{
        switch (tipo) {
          case 1:
            setFile_rg(file);
            break;
          case 2:
            setFile_cpf(file);
            break;
          case 3:
            setFile_cr(file);
            break;
          case 4:
            setFile_milhas(file);
            break;
          case 5:
            setFile_outros(file);
            break;
          default:
            break;
        }
      }
  }

  return (
    <div className="App">
      <Dialog 
        visible={load} 
        style={{ width: '70vw'}}
        closable={false}
        closeOnEscape={false}
        draggable={false}
      >
        <div className="load-spinner">
          <ProgressSpinner />
          <p>Preparando dados para o envio</p>
        </div>
      </Dialog>

      <div className="app-nav">
        <img src={logo}  className="nav-logo" alt="logo-dpe" />
        <p className="card-texto">
          Formulário de Reclamação da 123 Milhas
        </p>
      </div>
      <div className="app-main">
        <div className="main-card">

          <div className="card-form">
            <div className="card-form-a">
              <p className="labels">Nome *</p>
              <InputText value={nome} onChange={(e)=>setNome(e.target.value)}/>
            </div>
            <div className="card-form-b">
              <p className="labels">CPF *</p>
              <InputMask mask="999.999.999-99" value={cpf} onChange={(e)=>setCpf(e.target.value)}/>
            </div>
            <div className="card-form-b">
              <p className="labels">RG *</p>
              <InputText value={rg} onChange={(e)=>setRg(e.target.value)}/>
            </div>
          </div>

          <div className="card-form">
            <div className="card-form-a">
              <p className="labels">Endereço *</p>
              <InputText value={endereco} onChange={(e)=>setEndereco(e.target.value)}/>
            </div>
            <div className="card-form-b">
              <p className="labels">Telefone *</p>
              <InputMask mask="(99) 99999-9999" value={telefone} onChange={(e)=>setTelefone(e.target.value)}/>
            </div>
            <div className="card-form-b">
              <p className="labels">Email *</p>
              <InputText value={email} onChange={(e)=>setEmail(e.target.value)}/>
            </div>
          </div>


          <div className="card-form">
            <div className="card-form-a">
              <p className="labels">Valor da operação *</p>
              <InputText
                value={valor}
                onChange={(e)=>formatarMoeda(e.target.value)}
              />
            </div>
            <div className="card-form-a">
              <p className="labels">Anexo RG *</p>
              <span className='input-arquivo'>
                  <label className='label-file'
                    style={file_rg?{backgroundColor: "#56A54A"}: {backgroundColor: "#475569"} }
                  >
                    <span>
                        {file_rg ?
                        <span>
                          <i className="pi pi-file" style={{'fontSize': '1em'}}></i>{" "}
                          <span>{ file_rg.name }</span>
                        </span> 
                        :
                        <span>
                          <i className="pi pi-times" style={{'fontSize': '1em'}}></i>{" "}
                          <span>Nenhum arquivo selecionado</span>
                        </span> 
                        }
                    </span>
                    <input
                        value="" 
                        type="file" 
                        className='input-files' 
                        accept='application/pdf'
                        onChange={e=>changeFiles(e.target.files[0], 1)}
                    />
                  </label>
              </span>
            </div>
          </div>

          <div className="card-form">
            
            <div className="card-form-a">
              <p className="labels">Anexo CPF *</p>
              <span className='input-arquivo'>
                  <label className='label-file'
                    style={file_cpf?{backgroundColor: "#56A54A"}: {backgroundColor: "#475569"} }
                  >
                    <span>
                        {file_cpf ?
                        <span>
                          <i className="pi pi-file" style={{'fontSize': '1em'}}></i>{" "}
                          <span>{ file_cpf.name }</span>
                        </span> 
                        :
                        <span>
                          <i className="pi pi-times" style={{'fontSize': '1em'}}></i>{" "}
                          <span>Nenhum arquivo selecionado</span>
                        </span> 
                        }
                    </span>
                    <input
                        value="" 
                        type="file" 
                        className='input-files' 
                        accept='application/pdf'
                        onChange={e=>changeFiles(e.target.files[0], 2)}
                    />
                  </label>
              </span>
            </div>
            <div className="card-form-a">
              <p className="labels">Anexo comprovante de residência *</p>
              <span className='input-arquivo'>
                  <label className='label-file'
                    style={file_cr?{backgroundColor: "#56A54A"}: {backgroundColor: "#475569"} }
                  >
                    <span>
                        {file_cr ?
                        <span>
                          <i className="pi pi-file" style={{'fontSize': '1em'}}></i>{" "}
                          <span>{ file_cr.name }</span>
                        </span> 
                        :
                        <span>
                          <i className="pi pi-times" style={{'fontSize': '1em'}}></i>{" "}
                          <span>Nenhum arquivo selecionado</span>
                        </span> 
                        }
                    </span>
                    <input
                        value="" 
                        type="file" 
                        className='input-files' 
                        accept='application/pdf'
                        onChange={e=>changeFiles(e.target.files[0], 3)}
                    />
                  </label>
              </span>
            </div>
          </div>

          <div className="card-form">
            
            <div className="card-form-a">
              <p className="labels">Comprovante de pagamento 123 Milhas *</p>
              <span className='input-arquivo'>
                  <label className='label-file'
                    style={file_milhas?{backgroundColor: "#56A54A"}: {backgroundColor: "#475569"} }
                  >
                    <span>
                        {file_milhas ?
                        <span>
                          <i className="pi pi-file" style={{'fontSize': '1em'}}></i>{" "}
                          <span>{ file_milhas.name }</span>
                        </span> 
                        :
                        <span>
                          <i className="pi pi-times" style={{'fontSize': '1em'}}></i>{" "}
                          <span>Nenhum arquivo selecionado</span>
                        </span> 
                        }
                    </span>
                    <input
                        value="" 
                        type="file" 
                        className='input-files' 
                        accept='application/pdf'
                        onChange={e=>changeFiles(e.target.files[0], 4)}
                    />
                  </label>
              </span>
            </div>
            <div className="card-form-a">
              <p className="labels">Outros documentos 123 Milhas (voucher, emails, etc.)</p>
              <span className='input-arquivo'>
                  <label className='label-file'
                    style={file_outros?{backgroundColor: "#56A54A"}: {backgroundColor: "#475569"} }
                  >
                    <span>
                        {file_outros ?
                        <span>
                          <i className="pi pi-file" style={{'fontSize': '1em'}}></i>{" "}
                          <span>{ file_outros.name }</span>
                        </span> 
                        :
                        <span>
                          <i className="pi pi-times" style={{'fontSize': '1em'}}></i>{" "}
                          <span>Nenhum arquivo selecionado</span>
                        </span> 
                        }
                    </span>
                    <input
                        value="" 
                        type="file" 
                        className='input-files' 
                        accept='application/pdf'
                        onChange={e=>changeFiles(e.target.files[0], 5)}
                    />
                  </label>
              </span>
            </div>
          </div>

          <div className="card-form">
            <div className="card-form-c">
              <p className="labels">Descreva seu caso ({tam_descricao - conttexto} caracteres) *</p>
              <InputTextarea 
                value={texto} 
                onChange={(e) => chanceTexto(e.target.value)} 
                rows={5} 
                autoResize 
              />
            </div>
          </div>

          <p className="infos-forms">
            * Campos obrigatórios
          </p>

          <div className="card-rodape">

             <div className="rodape-check">
             <ReCAPTCHA
                sitekey={chaveRecaptcha}
                onChange={(response) => captcharFunction(response)}
                onExpire={() => expira_captcha()}
                language='pt-BR'
              />
            </div> 

            <div className="rodape-botao">
              {
                recaptcha?
                  <Button 
                    label="Enviar Dados" 
                    icon="pi pi-envelope" 
                    className="btn-1"
                    onClick={enviar_email} 
                  />
                :
                  <Button 
                    label="Enviar Dados" 
                    icon="pi pi-envelope" 
                    className="btn-1"
                    disabled 
                  />
              }
              
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default FormMilhas;
